// ====================================================================================
// panels.module
// ====================================================================================
import $ from "jquery";

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      const collapseHandler = (selector) => {
        let targets = Array.from(document.querySelectorAll(selector));
        targets.forEach((elem) => {
          $(elem).slideToggle(500).toggleClass("show");
          let shown = $(elem).hasClass("show");
          let panelBtn = $(elem).prev();

          if (shown) {
            panelBtn.children("button").attr("aria-expanded", "true");
            panelBtn.addClass("panel__btn--open");
          } else {
            panelBtn.children("button").attr("aria-expanded", "false");
            panelBtn.removeClass("panel__btn--open");
          }
        });
      };

      $("section .panel").on("click", function (ev) {
        let elem = ev.target;
        let parent = $(elem).closest(".panel__btn");

        if (parent.length) {
          let target = parent.find("button[data-target]").data("target");
          collapseHandler(target);
        }
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
